<template>
  <div>
    <v-dialog ref="dialog" persistent v-model="dialog" max-width="800">
      <v-card>
        <v-card-title>Alterar aula: {{ item.name }}</v-card-title>
        <v-card-text>
          <template>
            <v-row v-if="selected === 'other'">
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-if="loadingMatch"
              >
                <v-progress-circular indeterminate></v-progress-circular>
                Consultando horários disponíveis
              </v-col>
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-else
              >
                <span v-if="matched.length === 0">
                  Nenhum horário disponível</span
                >
                <div v-else style="height: 100%; width: 100%">
                  <date-picker ref="picker" :horarios="matched" />
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="close">
            <v-icon>mdi-clock-outline</v-icon>cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            circle
            plain
            @click="late"
            :disabled="selected === null"
          >
            <v-icon>mdi-check-outline</v-icon>Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import customerApi from "@/shared/pitchCustomerApi";
import { format } from "date-fns";
export default {
  name: "class-adiar-aluno-dialog",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      searchLevel: null,
      searchLevelLoading: false,
      loadingMatch: true,
      updateLeasson: false,
      newClassSelectContent: null,
      noContentMessage: false,
      matched: [],
      selected: null,

      dialog: false,
      postpone: false,
      canceling: false,
      motivo: "",
      englishLevels: [
        {
          text: "Beginner 1",
          value: 0,
        },
        {
          text: "Beginner 2",
          value: 1,
        },
        {
          text: "Essential 1",
          value: 2,
        },
        {
          text: "Essential 2",
          value: 3,
        },
        {
          text: "Pre Intermediate 1",
          value: 4,
        },
        {
          text: "Pre Intermediate 2",
          value: 5,
        },
        {
          text: "Intermediate 1",
          value: 6,
        },
        {
          text: "Intermediate 2",
          value: 7,
        },
        {
          text: "Upper 1",
          value: 8,
        },
        {
          text: "Upper 2",
          value: 9,
        },
        {
          text: "Advanced 1",
          value: 10,
        },
        {
          text: "Advanced 2",
          value: 11,
        },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.selected = "other";
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, "dd/MM/yyyy HH:mm");
    },
    late() {
      const item = Object.assign({}, this.item);
      item.data = this.$refs.picker.getData();
      this.$emit("confirm", { item, action: this.selected });
    },
  },
  watch: {
    selected: function (value) {
      if (value === "next") {
        this.canceling = true;
        this.updateLeasson = false;
      } else if (value === "cancel") {
        this.updateLeasson = true;
        this.canceling = false;
      } else if (value === "other") {
        customerApi.rearrange(this.item.id, this.item.classId).then((res) => {
          this.matched = res.data;
          this.loadingMatch = false;
        });
      } else this.canceling = false;
    },
  },
};
</script>
<style lang="css"></style>
